<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CustomerList',
})
</script>
<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="6" :sm="24">
                        <a-form-item label="平台" name="platform_id">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.platform_id"
                                placeholder="请选择">
                                <a-select-option v-for="(item, index) in data.platformList" :key="index"
                                    :value="item.id">{{ item.platform_abbreviation }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="公司名称" name="nameOrCode">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.nameOrCode"
                                placeholder="请输入公司名称、税号"> </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="续费联系人号码" name="xftel">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.xftel" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="代理商花名" name="seller">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.seller" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>
                    <template v-if="data.advanced">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="法人代表姓名" name="fr_name">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.fr_name" placeholder="请输入">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="地址编号" name="address_number">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.address_number"
                                    placeholder="请输入"> </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="主体类型" name="main_type">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.main_type"
                                    placeholder="请选择">
                                    <a-select-option :value="1">公司</a-select-option>
                                    <a-select-option :value="2">个体</a-select-option>
                                    <a-select-option :value="3">个人独资</a-select-option>
                                    <a-select-option :value="4">合伙企业</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="收费类型" name="fee_standard">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.fee_standard"
                                    placeholder="请选择">
                                    <a-select-option :value="1">按年收费</a-select-option>
                                    <a-select-option :value="2">一次性</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="付款状态" name="is_pay">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.is_pay"
                                    placeholder="请选择">
                                    <a-select-option :value="1">已付款</a-select-option>
                                    <a-select-option :value="2">未付款</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="入驻类型" name="business_type">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.business_type"
                                    placeholder="请选择">
                                    <a-select-option :value="1">设立</a-select-option>
                                    <a-select-option :value="2">同区迁入</a-select-option>
                                    <a-select-option :value="3">跨区迁入</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="进度状态" name="order_status">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.order_status_list"
                                    placeholder="请选择">
                                    <a-select-option v-for="(item, index) in data.progressOptions" :key="index"
                                        :value="item.value">{{ item.text }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="录入系统时间" name="between_time">
                                <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                                    @change="rangTimeChange" :format="format"></a-range-picker>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="是否查询已删除客户" name="recycle">
                                <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="是"
                                    un-checked-children="否" v-model:checked="queryParam.recycle"></a-switch>
                            </a-form-item>
                        </a-col>
                    </template>
                </a-row>
            </a-form>

            <div class="table-operator">
                <div></div>
                <div class="table-page-search-submitButtons" style="float: right; overflow: hidden; margin-bottom: 0">
                    <a-button type="primary" @click="loadData">查询</a-button>
                    <a @click="toggleAdvanced" style="margin-left: 8px">
                        {{ data.advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="data.advanced" />
                        <DownOutlined v-else />
                    </a>
                </div>
            </div>
        </div>

        <a-table rowClassName="tableRowClass" :columns="columns" :loading="data.loading" :data-source="dataSource"
            :pagination="pagination" @change="onChange">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex === 'companyInformation'">
                    <div class="companyInformation"
                        :style="[5, 6].includes(record.status) ? { borderLeft: '10px dashed #000' } : {}">
                        <a-tag color="grey" v-if="record.status === 5">该主体已删除</a-tag>
                        <a-tag v-else-if="record.status === 6" color="grey"> 主体删除审核中，如需撤销删除，请联系管理员</a-tag>
                        <div class="mv-1x">
                            <a-popover trigger="click" v-model:open="record.isShowCompany"
                                overlayClassName="customer-options-popover">
                                <template #content>
                                    <p @click="handleDoubleNameClick(record.tyc_url)">跳转到天眼查</p>
                                    <p @click="handleDoubleNameClick(record.qcc_url)">跳转到企查查</p>
                                </template>
                                <div style="width: 100%"></div>
                            </a-popover>
                            <span class="mr-1x pointer"
                                :style="record.status === 5 ? { textDecorationLine: 'line-through' } : {}"
                                @click="handleNameClick(record.full_name, record)">
                                <span v-html="record.fullName"></span>
                            </span>
                            <a-tag color="green" v-if="record.business_type == 1">设立</a-tag>
                            <a-tag color="blue" v-if="record.business_type == 2">同区迁入</a-tag>
                            <a-tag color="blue" v-if="record.business_type == 3">跨区迁入</a-tag>
                        </div>
                        {{ record.social_credit_code }}
                    </div>
                </template>
                <template v-else-if="column.dataIndex === 'full_address_number'">
                    <div @click="handleCopyClick(text)" class="pointer">
                        <div v-if="record.raw_address?.length > 0" style="border-bottom: 1px dashed #ccc">由：{{
                            record.raw_address }}</div>
                        <div><span v-if="record.raw_address?.length > 0">迁到：</span>{{ text }}</div>
                    </div>
                </template>

                <template v-else-if="column.dataIndex === '成立日期'">
                    <div v-if="record.isEdit1">
                        <a-date-picker :value="foundingTime(record.founding_time)" @change="
                            (val) => {
                                record.founding_time = dayjs(val).format('YYYY-MM-DD')
                            }
                        " :format="format" placeholder="请输入成立日期"></a-date-picker>
                        <div>
                            <a-button class="mr-2x" @click="loadData()" size="small">取消</a-button>
                            <a-button @click="editTimesChange(record, 'founding_time')" size="small"
                                type="primary">确认</a-button>
                        </div>
                    </div>
                    <span v-else @click="editTimes(index, 'isEdit1')" class="pointer founding_time">{{
                        record.founding_time || '无' }}
                        <EditOutlined />
                    </span>
                </template>

                <template v-else-if="column.dataIndex === 'verify_time'">
                    <div v-if="record.isEdit2">
                        <a-date-picker :value="foundingTime(record.verify_time)" @change="
                            (val) => {
                                record.verify_time = dayjs(val).format('YYYY-MM-DD')
                            }
                        " :format="format" placeholder="请输入核准日期"></a-date-picker>
                        <div>
                            <a-button class="mr-2x" @click="loadData()" size="small">取消</a-button>
                            <a-button @click="editTimesChange(record, 'verify_time')" size="small"
                                type="primary">确认</a-button>
                        </div>
                    </div>
                    <span v-else @click="editTimes(index, 'isEdit2')" class="pointer verify_time">{{ record.verify_time
                        || '无' }}
                        <EditOutlined />
                    </span>
                </template>

                <template v-else-if="column.dataIndex === 'status'">
                    <div v-if="record.work_order_status">
                        <p class="mb-x">
                            {{ record.work_order_status_name }}
                        </p>
                        <p class="mb-x">{{ record.work_order_created_at }}</p>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-else-if="column.dataIndex === 'seller'">
                    <p class="mb-x">
                        {{ record.seller ? record.seller : '-' }}<a @click="handleCopyClick(record.xftel)"
                            class="ml-1x">
                            <CopyOutlined />
                        </a>
                    </p>
                </template>
            </template>
        </a-table>
    </a-card>
</template>

<script lang="ts" setup name="CustomerList">
import { DownOutlined, UpOutlined, CopyOutlined, EditOutlined } from '@ant-design/icons-vue'
import type { PaginationProps } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, ref, onMounted, computed, onActivated } from 'vue'
import dayjs from 'dayjs'

const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const router = useRouter()
const format = 'YYYY-MM-DD HH:mm:ss'

interface data {
    advanced: boolean
    loading: boolean
    platformList: any[]
    progressOptions: any[]
}

const data = reactive<data>({
    advanced: false,
    loading: false,
    platformList: [],
    progressOptions: []
})

const columns = computed(() => {
    return [
        {
            title: '公司名称',
            dataIndex: 'companyInformation',
            width: 300
        },
        {
            title: '当前状态',
            dataIndex: 'status',
            width: 200
        },
        {
            title: '注册地址',
            dataIndex: 'full_address_number',
            width: 300
        },
        {
            title: '成立日期',
            dataIndex: '成立日期',
            width: 100
        },
        {
            title: '核准日期',
            dataIndex: 'verify_time',
            width: 100
        },
        {
            title: '录入日期',
            dataIndex: 'created_at',
            width: 100
        },
        {
            title: '代理商',
            dataIndex: 'seller',
            width: 100
        }
    ]
})

let queryParam = reactive<any>({
    order_status_list: [11],
    platform_id: [1, 3, 9, 11]
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '40', '50', '60'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})

onMounted(() => {
    platformList()
    loadData()
})

onActivated(() => {
    queryParam.nameOrCode = router.currentRoute.value.query.customer_name
    if (router.currentRoute?.value?.query?.customer_name) {
        loadData()
    }
})

// 跳转天眼查/企查查
const handleDoubleNameClick = (url) => {
    window.open(url)
}

const foundingTime = (val) => {
    if (!val) return null
    return dayjs(val, 'YYYY-MM-DD')
}

const editTimes = (index: number, fieldStr: string) => {
    dataSource.value[index][fieldStr] = true
}

// 修改时间
const editTimesChange = (record, fieldStr) => {
    let timestr = dayjs(record[fieldStr]).format('YYYY-MM-DD')

    let data: any = {
        customer_id: record.id,
        field_str: fieldStr,
        time_str: timestr
    }
    let requestParam = {
        url: '/admin/v1/customerAlterTime',
        method: 'post',
        data: data
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

// 时间选择
const rangTime = computed(() => {
    let array: any = []
    if (queryParam.between_time) {
        array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})

// 时间选择
const rangTimeChange = (val, str) => {
    if (val) {
        queryParam.between_time = str.join(',')
    } else {
        queryParam.between_time = null
    }
}

// 复制
const handleCopyClick = (val) => {
    var input = document.createElement('input')
    input.value = val
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    message.success('复制成功!')
    document.body.removeChild(input)
}

// 单击：复制 + 弹窗
const handleNameClick = (name, record) => {
    // 复制
    var input = document.createElement('input')
    input.value = name
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    message.success('复制成功!')
    document.body.removeChild(input)

    // 弹窗
    record.isShowCompany = true
}

// 列表数据
const loadData = () => {
    if (data.loading) {
        return
    }
    data.loading = true
    let requestParam = {
        url: '/admin/v1/customerList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, ishezhun: 2 }, queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            data.loading = false
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item) => {
                if (queryParam.nameOrCode) {
                    item.fullName = item.full_name.replace(queryParam.nameOrCode, `<span style="color: red">${queryParam.nameOrCode}</span>`)
                } else {
                    item.fullName = item.full_name
                }
                return { ...item, isShowCompany: false, isEdit1: false, isEdit2: false }
            })
            if (data.progressOptions != res.data.order_status_list) {
                data.progressOptions = res.data.order_status_list
            }
        })
        .catch((res) => {
            data.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('客户列表查询失败,请联系管理员')
            }
        })
}

// 获取平台数据
const platformList = () => {
    let requestParam = {
        url: '/admin/v1/platformList',
        method: 'post',
        data: { limit: 'all' }
    }
    baseService(requestParam)
        .then((res) => {
            data.platformList = res.data.list
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}

// 表格分页查询
const onChange = (val, filters) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    if (filters.status) {
        queryParam.order_status_list = filters.status
    }
    loadData()
}

const toggleAdvanced = () => {
    data.advanced = !data.advanced
}
</script>

<style lang="less" scoped>
:deep(.tableRowClass) {
    .ant-table-cell:first-child {
        padding: 0 !important;
    }
}

.table-operator {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px !important;
}

.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}

.companyInformation {
    padding: 16px;
}

.loading-message {
    .ant-message-notice-content {
        border: 1px solid #c8d8cf;
        color: rgb(8, 153, 68);
        background: rgb(233, 252, 241);
    }
}
</style>
